import React from 'react';
import styled from 'styled-components';

const QnAHeader = () => (
  <QnAHeaderWrapDiv>
    <QnAHeaderLeftWrapDiv>
      <QnAHeaderLoaderWrapDiv></QnAHeaderLoaderWrapDiv>
    </QnAHeaderLeftWrapDiv>
    <QnAHeaderLeftWrapDiv> </QnAHeaderLeftWrapDiv>
  </QnAHeaderWrapDiv>
);

export default QnAHeader;

const QnAHeaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  width:100%;
  justify-content: space-between;


`,
);

const QnAHeaderLeftWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:50%;

`,
);

const QnAHeaderLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:35.8rem;
  height:2.5rem;

`,
);
